export default __webpack_public_path__ + "static/media/images.f184c790.svg";